// src/app/components/reporting/components/quick-start-cards.tsx
import { Zap, TrendingUp, Users } from 'lucide-react';
import { QUICK_STARTS } from '../types';

const ICON_MAP = { Zap, TrendingUp, Users } as const;

interface QuickStartCardsProps {
  onSelect: (prompt: string, audience: string, format: string) => void;
}

export function QuickStartCards({ onSelect }: QuickStartCardsProps) {
  return (
    <div>
      <p
        style={{
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-weight-semibold)',
          marginBottom: '12px',
          color: 'var(--muted-foreground)',
        }}
      >
        Quick Start Examples:
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {QUICK_STARTS.map((qs) => {
          const Icon = ICON_MAP[qs.iconName as keyof typeof ICON_MAP];
          return (
            <button
              key={qs.id}
              onClick={() => onSelect(qs.prompt, qs.audience, qs.format)}
              className="p-3 md:p-4 rounded-xl text-left transition-all hover:translate-y-[-2px]"
              style={{
                backgroundColor: 'var(--background)',
                border: '1px solid var(--border)',
                cursor: 'pointer',
              }}
            >
              <div className="flex items-start gap-3">
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
                  style={{ backgroundColor: qs.color + '1A' }}
                >
                  <Icon className="w-4 h-4" style={{ color: qs.color }} />
                </div>
                <div className="min-w-0 flex-1">
                  <p
                    style={{
                      fontSize: 'var(--text-sm)',
                      lineHeight: '1.5',
                      overflowWrap: 'anywhere',
                      wordBreak: 'break-word',
                    }}
                  >
                    {qs.prompt}
                  </p>
                  <p
                    style={{
                      fontSize: 'var(--text-xs)',
                      color: 'var(--muted-foreground)',
                      marginTop: '4px',
                    }}
                  >
                    {qs.format} · {qs.audience}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}